import script from "./ClientMultiStepReservation.vue?vue&type=script&setup=true&lang=js"
export * from "./ClientMultiStepReservation.vue?vue&type=script&setup=true&lang=js"

import "./ClientMultiStepReservation.vue?vue&type=style&index=0&id=66356340&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-66356340"]])

export default __exports__